import React, { useEffect, useRef } from "react";
import Progressbar from "../Progressbar.js";
import "./side.css";
import NirantaraLogo from "../../assets/images/vajra_logo.svg";
import { Box } from "@mui/material";

function Sidebar(props) {
  const sidebarRef = useRef(null);

  useEffect(() => {
    const sidebarEl = sidebarRef.current;
    if (!sidebarEl) return;

    const handleScroll = () => {
      localStorage.setItem("sidebarScrollTop", sidebarEl.scrollTop);
    };

    sidebarEl.addEventListener("scroll", handleScroll);

    return () => {
      sidebarEl.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const sidebarEl = sidebarRef.current;
    const savedScrollTop = localStorage.getItem("sidebarScrollTop");

    if (sidebarEl && savedScrollTop) {
      sidebarEl.scrollTop = parseInt(savedScrollTop, 10);
    }
  }, []);
  return (
    <div className="d-flex flex-column  w-25  sidebar">
      <Box display="flex" justifyContent="center" p={2}>
        <img src={NirantaraLogo} alt="Vajra Logo" />
      </Box>

      <div
        className="d-flex flex-column gap-2  w-50 progressbar "
        style={{ fontSize: "14px", marginTop: "-1.2rem" }}
      >
        <div className="d-flex gap-1" ref={sidebarRef}>
          <Progressbar title={props.title} />
        </div>
      </div>
    </div>
  );
}

export default Sidebar;

// import React from 'react';
// import { Box, Stack } from '@mui/material';
// import './side.css';
// import NirantaraLogo from '../Assests/Nirantara-logo.jsx'; // Adjust the import path as needed
// import Progressbar from '../Progressbar'; // Adjust the import path as needed

// const Sidebar = (props) => {
//   return (
//     <Box
//       display="flex"
//       flexDirection="column"
//       width="25%"
//       className="sidebar"
//     >
//       <Box px={4}>
//         <NirantaraLogo />
//       </Box>

//       <Stack
//         direction="column"
//         spacing={2}
//         width="50%"
//         className="progressbar"
//         sx={{ fontSize: '14px' }}
//       >
//         <Box display="flex" gap={1}>
//           <Progressbar title={props.title} />
//         </Box>
//       </Stack>
//     </Box>
//   );
// };

// export default Sidebar;
